import { AppMedia, AppMediaKindEnum } from 'api/generated';
import { Button, Card, Drawer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Title, TopToolbar } from 'react-admin';
import { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { AddMediaFileForm } from 'components';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { api } from 'api';

const MediaFiles = () => {
  const [isFormOpened, setIsFormOpened] = useState<boolean>(false);
  const [mediaFiles, setMediaFiles] = useState<AppMedia[]>([]);

  const getFiles = async () => {
    try {
      const response = await api.V1AdminsAppMediaStorageApi.appMediaStorageControllerGetAllMedia();
      setMediaFiles(response.data);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    getFiles();
  }, []);

  const handleClose = () => {
    setIsFormOpened(false);
  };

  const deleteMediaFile = async (key: string) => {
    try {
      await api.V1AdminsAppMediaStorageApi.appMediaStorageControllerDeleteMedia(key);
      getFiles();
    } catch (error: any) {
      console.log('error', error.message);
    }
  };

  const activateMediaFile = async (file: AppMedia) => {
    try {
      if (file.kind == AppMediaKindEnum.MainPageFirstVideo) {
        await api.V1AdminsAppMediaApi.adminAppMediaControllerSetMainPageFirstVideo({ name: file.name });
        getFiles();
      } else {
        await api.V1AdminsAppMediaApi.adminAppMediaControllerSetMainPageSecondVideo({ name: file.name });
        getFiles();
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <>
      <TopToolbar>
        <Button startIcon={<AddIcon />} onClick={() => setIsFormOpened(!isFormOpened)}>
          Добавить
        </Button>
      </TopToolbar>
      <Card>
        <Title title={'Медиа файлы'} />
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Имя</TableCell>
              <TableCell>Тип</TableCell>
              <TableCell></TableCell>
              <TableCell>Статус</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mediaFiles
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((file) => (
                <TableRow key={file.id}>
                  <TableCell>{file.name}</TableCell>
                  <TableCell>{file.kind}</TableCell>
                  <TableCell>
                    <video src={`${file.s3Link}`} controls width="240" height="180"></video>
                  </TableCell>
                  <TableCell>
                    {file.isActive ? (
                      'На главной странице'
                    ) : (
                      <Button onClick={() => activateMediaFile(file)}>Поставить на главную</Button>
                    )}
                  </TableCell>
                  <TableCell>
                    <Button color="error" startIcon={<DeleteForeverIcon />} onClick={() => deleteMediaFile(file.s3Key)}>
                      Удалить
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Card>
      <Drawer variant="persistent" open={isFormOpened} anchor="right" onClose={handleClose}>
        {isFormOpened && <AddMediaFileForm handleClose={handleClose} getFiles={getFiles} />}
      </Drawer>
    </>
  );
};

export default MediaFiles;
